import React, { useCallback } from 'react'
import List from '@commonComponents/List'
import { AddBtn } from '@commonComponents/AddBtn'
import Invoice from './Invoice'
import { useDispatch, useSelector } from 'react-redux'
import { itemActions } from '../../reducer/ItemSlice'
import {useEvent} from '@hooks/useEvent'
import AccordionInvoice from '@commonComponents/accordion/AccordianInvoice'

const InvoiceDetail = ({ translate }) => {
  const { isLoading, saveForm } = useEvent('invoiceTab', true)
  const dispatch = useDispatch()
  const {createInvoice} = itemActions
  const dataSource = useSelector(state => state.invoiceReducer.invoice.invoiceIdList)
  const addInvoice = useCallback(async () => {
    const response = await saveForm({ invoiceMap: { '': {id:''} } }, true)
    if (response) {
      const invoiceId = response.invoiceTab.invoiceIdList[0]
      dispatch(createInvoice({ invoiceId }))
    }
  }, [createInvoice, saveForm])
  

  return (
    <>
        {
        dataSource?.length>0 && 
        <AccordionInvoice
        initialiState={{[dataSource?.[0]]:true}}
        keyName={"toggleInvoices"} 
        expandTitle={"OPEN_ALL_INVOICES"}
        collapseTitle={"CLOSE_ALL_INVOICES"}
        >
        {dataSource?.map((invoiceId, index) => {
          return (
            <Invoice
            key={`invoice${invoiceId}`}
            id={invoiceId}
            invoiceId={invoiceId}
            invoiceIndex={index} />

          )
        })
        
      }

        </AccordionInvoice>
      }
      <AddBtn onClick={addInvoice} text={translate('ADD_INVOICE')} size='tiny' />
    </>
  )
}

export default React.memo(InvoiceDetail)
